// extracted by mini-css-extract-plugin
export const bannerSection = "styles-module--bannerSection--VKOTv";
export const overlay = "styles-module--overlay--QuEKD";
export const banner = "styles-module--banner--6cvfV";
export const bannerContent = "styles-module--bannerContent--U2+mS";
export const bannerTitle = "styles-module--bannerTitle--m2cXP";
export const bannerSubTitle = "styles-module--bannerSubTitle--+cu2t";
export const btnPromote = "styles-module--btnPromote--VUBEz";